import React, { ReactElement } from "react";
import { makeStyles } from "@material-ui/core";
import theme from "../../../themes";
import useRedirect from "../../common/Hooks/useRedirect";
import LogoImage from "../../common/utilities/LogoImage";
import { useEnumStrings } from "../../enumStrings";

const useStyles = makeStyles((themes: any) => ({
  chamberContainer: {
    display: "flex",
    alignItems: "center",
    width: "471px",
    margin: "auto",
    backgroundColor: "white",
    marginBottom: "20px",
    borderRadius: "15px",
    [theme.breakpoints.down("sm")]: {
      width: "341px",
    },
    [theme.breakpoints.up("sm")]: {
      width: "471px",
    },
    cursor: "pointer",
    position: "relative",
  },
  deletedChamberContainer: {
    cursor: "default",
    backgroundColor: "#EDEDED",
    "& $imageContainer, & $chamberTitle": {
      opacity: 0.5,
      filter: "grayscale(100%)",
    },
  },
  // room above the logo and name so the badges never cover a long name
  chamberContainerWithBadges: {
    paddingTop: "30px",
  },
  badgeContainer: {
    position: "absolute",
    top: "10px",
    right: "12px",
    display: "flex",
    gap: "6px",
  },
  badge: {
    color: "white",
    fontSize: "12px",
    fontWeight: "bold",
    lineHeight: "18px",
    padding: "1px 10px",
    borderRadius: "999px",
  },
  imageContainer: {
    margin: 15,
  },
  chamberTitle: {
    width: "100%",
    marginLeft: "15px",
    marginRight: "15px",
    maxWidth: "230px",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "50px",
      fontSize: "1em",
    },
    [theme.breakpoints.up("sm")]: {
      maxWidth: "230px",
      fontSize: "2em",
    },
  },

  chamberList: {
    background: "#F6F6F6",
  },
  underline: {
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
}));
const ChamberCard = ({
  chamberName,
  chamberLogo,
  chamberURL,
  redirectStates = {},
  offersPerk,
  badges = [],
  isDeleted = false,
}: {
  indexVal: number;
  chamberName: string;
  chamberLogo?: any;
  chamberURL: string;
  redirectStates?: { [key: string]: any };
  offersPerk?: any;
  badges?: { label: string; color: string }[];
  isDeleted?: boolean;
}): ReactElement => {
  const classes = useStyles();
  const enumStrings = useEnumStrings();

  const redirectToChamber = useRedirect(chamberURL, redirectStates);

  return (
    <div
      className={`${classes.chamberContainer} ${
        badges.length === 0 ? "" : classes.chamberContainerWithBadges
      } ${isDeleted ? classes.deletedChamberContainer : ""}`}
      aria-disabled={isDeleted || undefined}
    >
      {badges.length === 0 ? null : (
        <div className={classes.badgeContainer}>
          {badges.map((badge) => (
            <span
              key={badge.label}
              className={classes.badge}
              style={{ backgroundColor: badge.color }}
            >
              {badge.label}
            </span>
          ))}
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row-reverse",
          alignItems: "center",
          width: "100%",
        }}
        onClick={isDeleted ? undefined : redirectToChamber}
      >
        <div className={classes.chamberTitle}>
          <span>{chamberName}</span>
          {!offersPerk ? null : (
            <div
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                color: "#E1A731",
              }}
            >
              {enumStrings.offersPerkText}
            </div>
          )}
        </div>
        <div className={classes.imageContainer}>
          {/* @ts-ignore */}
          <LogoImage
            logoSource={chamberLogo}
            size="large"
            squared
            chamberName={chamberName}
          />
        </div>
      </div>
    </div>
  );
};

export default ChamberCard;
